import React from "react";

const CheckBox = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" {...props}>
    <g clipPath="url(#clip0_8004_12880)">
      <rect x="0.5" y="1" width="19" height="19" stroke="#E0E0E0" />
    </g>
    <defs>
      <clipPath id="clip0_8004_12880">
        <rect y="0.5" width="20" height="20" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CheckBox;
